import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import { t } from '../../../../modules/infra/i18n';
import Money from '../../../common/money';
import Pagination from '../../../common/Pagination';
import MembershipActions from './MembershipActions';
import { MEMBERSHIPS_LIST_PAGE_SIZE } from './MembershipsListContainer';
import MembershipsStatsComponent from './MembershipsStats';
import enhanceStats from './MembershipsStatsContainer';

const MembershipsStats = enhanceStats(MembershipsStatsComponent);

const MembershipsList = (props) => (
  <div className="u-width-100">
    <div className="u-text-right">
      <button className="c-btn c-btn--medium" onClick={props.addMembership}>
        {t('memberships:memberships_list.add_membership_button')}
      </button>
      <button className="c-btn c-btn--medium u-ml-" onClick={props.importSubscriptions}>
        {t('memberships:memberships_list.import_subscriptions_button')}
      </button>
    </div>
    <MembershipsStats display-if={props.canViewStats()} />
    <ReactTable
      className="c-memberships-table c-table-new c-table-paginated u-mt+ u-mb c-no-hover"
      data={props.activePageItems}
      minRows={0}
      defaultPageSize={MEMBERSHIPS_LIST_PAGE_SIZE}
      showPagination={false}
      resizable={false}
      noDataText={t('memberships:common.no_rows_found')}
      getTrProps={(state, row) => {
        const isDisabled = props.pendingMemberships[row.original.id];
        return {
          className: cx({
            'u-opacity': isDisabled,
            'no-pointer-events': isDisabled,
          }),
        };
      }}
      columns={[
        {
          Header: t('memberships:memberships_list.table.membership_name_header'),
          accessor: 'name',
          id: 'name',
        },
        {
          Header: t('memberships:memberships_list.table.members_header'),
          accessor: (row) => row.counts.total,
          id: 'total',
        },
        {
          Header: t('memberships:memberships_list.table.active_members_header'),
          accessor: (row) => row.counts.active,
          id: 'active',
        },
        {
          Header: t('memberships:memberships_list.table.paused_members_header'),
          accessor: (row) => row.counts.paused,
          id: 'paused',
        },
        {
          Header: t('memberships:memberships_list.table.projected_monthly_revenue_header'),
          accessor: 'projectedMonthlyRevenue',
          id: 'projectedMonthlyRevenue',
          Cell: (row) => (row.value ? <Money>{row.value}</Money> : t('memberships:common.not_available')),
        },
        {
          Header: t('memberships:memberships_list.table.actions_header'),
          id: 'actions',
          Cell: (row) => (
            <MembershipActions
              membership={row.original}
              copyMembership={props.copyMembership}
              editMembership={props.editMembership}
              viewMembership={props.viewMembership}
              archiveMembership={props.archiveMembership}
              canCopyMembership={props.canCopyMembership(row.original)}
              canEditMembership={props.canEditMembership(row.original)}
              canViewMembership={props.canViewMembershipAssignees(row.original)}
              canArchiveMembership={props.canArchiveMembership(row.original)}
            />
          ),
        },
      ]}
    />
    <div className="c-heading c-heading--small u-mt" display-if={!props.activePageItems.length}>
      {t('memberships:common.no_rows_found')}
    </div>
    <Pagination
      display-if={props.totalPages > 1}
      onPageChange={props.openPage}
      pageCount={props.totalPages}
      currentPage={props.activePage}
    />
  </div>
);

MembershipsList.propTypes = {
  addMembership: PropTypes.func.isRequired,
  importSubscriptions: PropTypes.func.isRequired,
  activePageItems: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  activePage: PropTypes.number.isRequired,
  openPage: PropTypes.func.isRequired,
  pendingMemberships: PropTypes.object.isRequired,
  editMembership: PropTypes.func.isRequired,
  viewMembership: PropTypes.func.isRequired,
  copyMembership: PropTypes.func.isRequired,
  archiveMembership: PropTypes.func.isRequired,
  canViewMembershipAssignees: PropTypes.func.isRequired,
  canEditMembership: PropTypes.func.isRequired,
  canCopyMembership: PropTypes.func.isRequired,
  canArchiveMembership: PropTypes.func.isRequired,
  canPerformActions: PropTypes.func.isRequired,
  canViewStats: PropTypes.func.isRequired,
};

export default MembershipsList;
